
import EnhancedUserProfile from "@/components/user-profile/EnhancedUserProfile";
import { OrganizationInfo } from "@/components/user-profile/OrganizationInfo";

export default function UserProfile() {
  return (
    <div className="space-y-6">
      <EnhancedUserProfile />
      <div className="max-w-4xl mx-auto px-6">
        <OrganizationInfo />
      </div>
    </div>
  );
}
